<template>
  <v-row>
    <v-col cols=12 class="pa-0">
      <v-menu :value="shown" offset-y :close-on-content-click=false bottom left>
          <template v-slot:activator="{ on }">
            <v-btn dark icon v-on="on" @click="shown = true">
              <v-icon color="var(--v-primary-lighten1)" size="16">mdi-filter</v-icon>
            </v-btn>
          </template>
          <v-card tile dense class="pl-1 pr-1">
            <v-form @submit="applyFilter" onSubmit="return false;">
            <v-card-text class="pt-2 pb-0">
              <v-row dense class="ma-0 pa-0">
                <v-col cols=12 class="pa-0">
                  <component
                    :is="type"
                    v-model="model"
                    :label="label"
                    :disabled="disabled"
                    :readonly="readonly"
                    :items="items">
                  </component>
                </v-col>
              </v-row>
            </v-card-text>
              <v-card-actions class="mb-0">
                <v-row>
                <v-col cols=12>
                  <v-btn small text class="text-none ma-0" type="submit" dark color="primary">
                    <v-icon left>mdi-check</v-icon>
                    {{applyLabel}}
                  </v-btn>
                </v-col>
              </v-row>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-menu>
    </v-col>
  </v-row>
</template>
<script>
import MoneyRange from './money-range/MoneyRange'
import TextRange from './text-range/TextRange'
import BoolSelect from './bool-select/BoolSelect'
import TextSelect from './text-select/TextSelect'
import YearSelect from './year-select/YearSelect'
import DateTimePicker from './datetime-picker/DatetimePicker'
import DateTimeRangePicker from './datetime-picker/DatetimeRangePicker'
import DateRangePicker from './date-picker/DateRangePicker'
import i18n from '@/i18n'

export default {
  name: 'header-input',
  components: {
    MoneyRange,
    TextRange,
    BoolSelect,
    TextSelect,
    DateTimePicker,
    DateTimeRangePicker,
    DateRangePicker,
    YearSelect
  },
  data () {
    return {
      model: this.value,
      debounce: '',
      shown: false,
      applyLabel: i18n.t('form.apply')
    }
  },
  props: {
    type: {
      type: String,
      default: 'v-text-field'
    },
    vuetify_ref: {},
    value: {},
    label: {
      type: String,
      default: ''
    },
    changeCallback: {
      type: Function
    },
    cancelCallback: {
      type: Function
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array
    }
  },
  created () {
    this.$vuetify = this.$props.vuetify_ref
  },
  methods: {
    applyFilter () {
      this.changeCallback(this.model)
      this.shown = false
    }
  }
}
</script>
<style lang="scss" type="text/scss">
  .tabulator {
    font-size: 12px !important;
    .v-text-field__prefix{
      font-size: 12px;
      font-weight: 400;
    }
    .theme--dark.v-messages {
      display: none !important;
    }

    .v-input{
      padding-top: 0px;
      margin-top: 1px;
      input {
        color: var(--v-caption-base) !important;
        font-weight: 500;
      }
    }
    .v-input__slot{
      margin-bottom: 1px;
      color: var(--v-subcaption-base) !important;
      .v-label {
        color: var(--v-subcaption-base);
      };
      label {
        left: calc(50% - 35px) !important;
      }
    }
    .v-text-field{
      label{
        top: -5px;
        height: 15px;
        line-height: 15px;
        font-size: 12px;
      }
      input{
        padding: 2px 0 2px;
        line-height: 12px;
        font-size: 12px;
        font-style: italic;
      }
    }
  }
</style>
